import { Component, createElement } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import assign from 'lodash/assign';
import uniqueId from 'lodash/uniqueId';
import each from 'lodash/each';
import isObject from 'lodash/isObject';
import ObservedRequest from './ObservedRequest';

export const propTypes = {
  observeRequest: PropTypes.func,
  getObservedRequest: PropTypes.func,
  componentUpdateToken: PropTypes.any,
};

export default WrappedComponent =>
  class WithRequestDecorator extends Component {
    constructor() {
      super();
      this.observableRequests = {};
      this.state = { componentUpdateToken: null };
      this.mounted = false;
    }

    componentDidMount() {
      this.mounted = true;
    }

    componentWillUnmount() {
      each(this.observableRequests, oR => oR.abort());
      this.mounted = false;
    }

    getObservedRequest = (id = '') => {
      return this.observableRequests[id] || new ObservedRequest();
    };

    observeRequest = async (getRequest, { id = '', shouldComponentUpdate = true } = {}) => {
      // Cancel existing request with same id
      this.getObservedRequest(id).abort();

      // Get request
      const cancelTokenSource = axios.CancelToken.source();
      const request = getRequest(cancelTokenSource.token);

      // Create new observation
      const obsReq = new ObservedRequest(request, cancelTokenSource);
      this.observableRequests[id] = obsReq;

      // Update component on pending
      this.updateComponentIfNeeded(shouldComponentUpdate, 'pending');

      try {
        const data = await request;
        obsReq.resolve();
        this.updateComponentIfNeeded(shouldComponentUpdate, 'success');
        return data;
      } catch (error) {
        obsReq.reject(error);
        this.updateComponentIfNeeded(shouldComponentUpdate, 'failure');
        throw error;
      }
    };

    updateComponentIfNeeded(shouldComponentUpdate, phase) {
      const scu = isObject(shouldComponentUpdate) ?
        assign({
          pending: true,
          success: true,
          failure: true,
        }, shouldComponentUpdate) :
        shouldComponentUpdate;

      if (scu === true || (isObject(scu) && scu[phase])) {
        this.updateComponent();
      }
    }

    updateComponent() {
      if (this.mounted) {
        this.setState({ componentUpdateToken: uniqueId('componentUpdateToken') });
      }
    }

    render() {
      const { componentUpdateToken } = this.state;
      return createElement(WrappedComponent, {
        ...this.props,
        observeRequest: this.observeRequest,
        getObservedRequest: this.getObservedRequest,
        componentUpdateToken
      });
    }
  };



// WEBPACK FOOTER //
// ./src/decorators/withRequest/index.js